import setts from "@/config/setts";

const baseURL = setts.state
  ? "https://830708357d42.sn.mynetname.net"
  : "https://app.mechaxvr.com";

const versionAPI = "api/v1/";

export default {
  DOMAIN: baseURL,
  storage: `${baseURL}/storage/`,
  streams: {
    CRUD: `${versionAPI}streams`,
    uploadPoster: `${versionAPI}streams/upload-poster`,
    likes: `${versionAPI}streams/toggle-like`,
    updateStat: `${versionAPI}streams/update-info`,
    shared: `${versionAPI}streams/shared`,
    updateOnStopOfStream: `${versionAPI}streams/stop-stream`
  },
  users: {
    CRUD: `${versionAPI}users`,
    login: `oauth/token`,
    register: `${versionAPI}auth/register`,
    update: `${versionAPI}auth/update`,
    logout: `${versionAPI}auth/logout`,
    info: `${versionAPI}user`
  }
};
